import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { ConnectedRouter } from "react-router-redux";
import { connect } from "react-redux";

import App from "./containers/App/App";
import asyncComponent from "./helpers/AsyncFunc";

const RestrictedRoute = ({ component: Component, isLoggedIn, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isLoggedIn ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/",
            state: { from: props.location },
          }}
        />
      )
    }
  />
);
const PublicRoutes = ({ history, isLoggedIn }) => {
  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Route
          exact
          path={"/"}
          component={asyncComponent(() => import("./containers/Auth/signin"))}
        />
        <Route
          exact
          path={"/signin"}
          component={asyncComponent(() => import("./containers/Auth/signin"))}
        />
        <Route
          exact
          path={"/meeting/:id"}
          component={asyncComponent(() =>
            import("./containers/PublicPath/MeetingLanding")
          )}
        />
        <Route
          exact
          path={"/dashboard/resource-preview/"}
          component={asyncComponent(() =>
            import("./containers/Courses/PDFPreviewPage")
          )}
        />
        <Route
          exact
          path={"/reset-password/:token/"}
          component={asyncComponent(() =>
            import("./containers/Auth/resetPassword")
          )}
        />
        <Route
          exact
          path={"/bot/"}
          component={asyncComponent(() =>
            import("./containers/AnaBot")
          )}
        />
        <Route
          exact
          path={"/droprules"}
          component={asyncComponent(() => import("./containers/DropRules"))}
        />
        <RestrictedRoute
          path="/dashboard"
          component={App}
          isLoggedIn={isLoggedIn}
        />
        <Route
          component={asyncComponent(() => import("./containers/notFound"))}
        />
      </Switch>
    </ConnectedRouter>
  );
};

export default connect((state) => ({
  isLoggedIn: state.Auth.get("idToken") !== null,
}))(PublicRoutes);
